import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_hauteur-pro-1/artifacts/p4h5h94e_Capture%20d%E2%80%99%C3%A9cran%202026-01-21%20171314.jpg" 
                alt="Riviera Rope Access" 
                className="h-12 w-auto"
              />
              <div className="ml-3">
                <h3 className="font-bold text-lg">Riviera Rope Access</h3>
              </div>
            </div>
            <p className="text-slate-400 leading-relaxed">
              Experts en travaux d'accès difficile sur la Côte d'Azur. 
              Certifiés CQP Cordiste et IRATA International.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Nos Services</h4>
            <ul className="space-y-2 text-slate-400">
              <li className="hover:text-white transition-colors cursor-pointer">Maçonnerie de façade</li>
              <li className="hover:text-white transition-colors cursor-pointer">Mise en sécurité</li>
              <li className="hover:text-white transition-colors cursor-pointer">Système anti-volatiles</li>
              <li className="hover:text-white transition-colors cursor-pointer">Nettoyage vitres & façades</li>
              <li className="hover:text-white transition-colors cursor-pointer">Travaux de toiture</li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Contact</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin className="text-blue-400 mt-1 flex-shrink-0" size={20} />
                <p className="text-slate-400">37 avenue Cyrnos<br />06100 Nice, France</p>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="text-blue-400 flex-shrink-0" size={20} />
                <a href="tel:0760506758" className="text-slate-400 hover:text-white transition-colors">
                  07 60 50 67 58
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="text-blue-400 flex-shrink-0" size={20} />
                <a href="mailto:contact@riviera-rope-access.fr" className="text-slate-400 hover:text-white transition-colors">
                  contact@riviera-rope-access.fr
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-400 text-sm">
              © 2025 Riviera Rope Access. Tous droits réservés.
            </p>
            <div className="flex space-x-6 text-sm text-slate-400">
              <a href="#" className="hover:text-white transition-colors">Mentions légales</a>
              <a href="#" className="hover:text-white transition-colors">Confidentialité</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;